module.exports = __webpack_public_path__ + "static/ff-7ce02d5349f7ffef8754fbfece5581bb.png";